<template>
  <CustomModal id="report-content-modal"
               class="basic-modal"
               v-bind:title="$t('common.modal.report_content.title')"
               v-bind:close-title="$t('common.cancel')"
               v-bind:ok-title="$t('common.confirm')"
               v-bind:ok-busy="busy"
               v-on:cancel="$emit('cancel')"
               v-on:ok="reportContent()">
    <div>
      <Radio id="option-content-has-error"
             v-bind:model-value="reportIssue"
             v-bind:check-value="1"
             v-on:change="onRadioSelect">
        <span slot="label">
          {{ $t('common.modal.report_content.options.has_error') }}
        </span>
      </Radio>

      <Radio id="option-content-is-inappropriate"
             v-bind:model-value="reportIssue"
             v-bind:check-value="2"
             v-on:change="onRadioSelect">
        <span slot="label">
          {{ $t('common.modal.report_content.options.inappropriate') }}
        </span>
      </Radio>
    </div>
  </CustomModal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { isNil } from 'lodash';

  export default {
    name: 'report-content-modal',

    props: {
      card: {
        type: Object,
        default: null,
      },
      page: {
        type: Object,
        default: null,
      },
    },

    data() {
      return {
        reportIssue: 1,
        busy: false,
      };
    },

    computed: {
      ...mapGetters([
        'currentUserId',
        'currentUser',
      ]),

      reportIssueText() {
        if (this.reportIssue === 1) {
          return this.$t('common.modal.report_content.options.has_error');
        }

        return this.$t('common.modal.report_content.options.inappropriate');
      },
    },

    methods: {
      ...mapActions([
        'sendSlackContentReports',
      ]),

      onRadioSelect(value) {
        this.reportIssue = value;
      },

      reportContent() {
        if (!this.busy && !isNil(this.card) && !isNil(this.page)) {
          this.busy = true;

          const params = {
            card_id: this.card.copy_id || this.page.card_id || this.card.card_id || null,
            store_card_id: this.card.store_card_id || null,
            card_title: this.card.title || this.page.card_title,
            page_id: this.page.id,
            page_position: this.page.position,
            card_publisher_name: this.card.publisher_name || this.page.publisher_name || null,
            card_publisher_id: this.card.publisher_id || this.page.publisher_id || null,
            card_author_name: this.card.author_name || this.page.author_name || null,
            card_author_id: this.card.author_id || this.page.author_id || null,
            card_subject_id: this.card.subject_id || null,
            card_grade_id: this.card.grade_id || this.page.grade_id || null,
            user_id: this.currentUserId || null,
            user_name: this.currentUser.name || null,
            user_role: this.currentUser.role || null,
            reason: this.reportIssueText,
            reported_from: this.$route.fullPath,
            reported_at: (new Date()).toString(),
          };

          this.sendSlackContentReports(params)
            .then(() => {
              this.busy = false;
              this.$emit('ok');
            });
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ReportContentModal.vue